import _toConsumableArray from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React from 'react';
import NavMenu from '../../../molecules/NavList';
import { HEADER_PARENTS } from '../../../../constants/globalConstants';
var CTAMenu = function CTAMenu(_ref) {
  var ctaMenuCollection = _ref.ctaMenuCollection,
    parent = _ref.parent,
    openDropdownOnClick = _ref.openDropdownOnClick;
  var ctaMenu = parent === HEADER_PARENTS.DESKTOP_GRID ? _toConsumableArray(ctaMenuCollection.items).reverse() : ctaMenuCollection.items;
  return __jsx("div", {
    className: "nva-header__cta-menu"
  }, __jsx(NavMenu, {
    className: "nva-header__cta-menu-list",
    menu: ctaMenu,
    menuType: "cta",
    parent: parent,
    openDropdownOnClick: openDropdownOnClick
  }));
};
export default CTAMenu;